import { useDataValue, useDataChange } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

export function useOnChange(props) {
  let types = useDataValue({
    context: 'charge_types',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'charge',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onChange(value) {
    let type = types.find(item => item.id === value)

    change(next => {
      next.type_id = type.id
      next.name = type.name
      next.amount = type.price
      next.affecting_production_report = type.affecting_production_report
      next.insurance_code_id = type.insurance_code_id
      next.requires_tooth_details = type.requires_tooth_details
    })

    if (!type.insurance_code_id) {
      setFlowTo(
        normalizePath(props.viewPath, '../../EditInsuranceCode/Content')
      )
      return
    }
  }
}
